import { BrowserAgent } from '@newrelic/browser-agent'
import { ENV_DEVELOPMENT, ENV_LOCAL, ENV_LOCAL_TEST, ENV_PRODUCTON } from '../../constants'

const newRelicApplicationIDs: Record<string, string> = {
    [ENV_DEVELOPMENT]: "1386260340",
    [ENV_PRODUCTON]: "1409585261",
}

let hasInstantiatedNewRelic = false

interface INewRelicConfigOptionsDefault {
    init: {
        distributed_tracing: { enabled: boolean }
        privacy: { cookies_enabled: boolean }
        ajax: { deny_list: string[] }
        jserrors: { enabled: boolean }
    }
    info: {
        beacon: string
        errorBeacon: string
        licenseKey: string
        sa: number
    }
    loaderConfig: {
        accountID: string
        trustKey: string
        licenseKey: string
    }
}

interface INewRelicConfigOptions extends Omit<INewRelicConfigOptionsDefault, 'info' | 'loaderConfig'> {
    info: INewRelicConfigOptionsDefault['info'] & {
        applicationID: string
    }
    loaderConfig: INewRelicConfigOptionsDefault['loaderConfig'] & {
        applicationID: string
        agentID: string
    }
}

const newRelicConfigOptionsDefault: INewRelicConfigOptionsDefault = {
    init: {
        distributed_tracing: {enabled:true},
        privacy:{cookies_enabled:true},
        ajax:{deny_list:["bam.nr-data.net"]},
        jserrors: { enabled: true }
    },
    info: {
        beacon:"bam.nr-data.net",
        errorBeacon:"bam.nr-data.net",
        licenseKey:"NRJS-4cb3aeb743caa6db017",
        sa:1
    },
    loaderConfig: {
        accountID:"3061395",
        trustKey:"3061395",
        licenseKey:"NRJS-4cb3aeb743caa6db017"
    }
}

const createNewRelicConfig = (applicationID: string): INewRelicConfigOptions => ({
    ...newRelicConfigOptionsDefault,
    info: {
        ...newRelicConfigOptionsDefault.info,
        applicationID,
    },
    loaderConfig: {
        ...newRelicConfigOptionsDefault.loaderConfig,
        applicationID,
        agentID: applicationID,
    },
})

const instantiateNewRelic = (env: Pick<ImportMetaEnv, 'VITE_REACT_APP_SENTRY_ENVIRONMENT'> = import.meta.env): void => {
    const environment = env.VITE_REACT_APP_SENTRY_ENVIRONMENT;

    if (!environment || environment === ENV_LOCAL || environment === ENV_LOCAL_TEST) {
        return
    }

    const newRelicApplicationID = newRelicApplicationIDs[environment]

    if (newRelicApplicationID) {
        const config = createNewRelicConfig(newRelicApplicationID)
        new BrowserAgent(config)
        hasInstantiatedNewRelic = true
    } else {
        // eslint-disable-next-line no-console
        console.error(`New Relic not instantiated: No application ID found for environment: ${environment}`)
    }
}

export { instantiateNewRelic, createNewRelicConfig, hasInstantiatedNewRelic }